import { AB_TEST_V3_REGISTRY } from '@/utils/abtest/abTestV3Config'
import { useABTestV3Store } from '@/store/ab_test_v3'
import { resolveAbTest } from '@/utils/abtest/abTestV3Resolver'

export default defineNuxtPlugin(() => {
  const store = useABTestV3Store()

  AB_TEST_V3_REGISTRY.forEach(config => {
    const result = resolveAbTest(config)
    store.setResult(config.testName, result)
  })
})
